import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponsePayload } from '#interfaces/response-payload.interface';
import { AppHttpClient } from '#services/app-http-client.service';
import { Repository } from './repository';
import { map } from 'rxjs/operators';
import { Order } from '#models/order.model';

@Injectable()
export class OrderRepository extends Repository {
  constructor(httpClient: AppHttpClient) {
    super(httpClient);
  }

  setOrderStatus(id: number, status: number): Observable<ResponsePayload<any>> {
    return this.httpClient.put(`/admin/orders/${id}`, {
      is_done: status,
    });
  }

  getOrder(id: number): Observable<Order> {
    return this.httpClient
      .get(`/admin/orders/${id}`, {}, { needHandle: true })
      .pipe(
        map((payload: ResponsePayload<Order>) =>
          new Order().mapFromAPI(payload?.data)
        )
      );
  }
}
